// @flow

import {
  SET_CURRENT_ORGANIZATION,
  START_SET_CURRENT_ORGANIZATION,
  END_SET_CURRENT_ORGANIZATION,
  SET_MAX_ACTIVE_QUESTS
} from '../actions/organization'

const initialState : {
  orgId: ?number,
  maxActiveQuests: number,
  isChangingOrganization: boolean
} = {
  orgId: null,
  maxActiveQuests: 6, // default
  isChangingOrganization: false
}

export function organization (state: Object = initialState, action: Object) : Object {
  switch (action.type) {

    case SET_CURRENT_ORGANIZATION:
      return Object.assign({}, state, {
        orgId: action.orgId
      })

    case START_SET_CURRENT_ORGANIZATION:
      return Object.assign({}, state, {
        isChangingOrganization: true
      })

    case END_SET_CURRENT_ORGANIZATION:
      return Object.assign({}, state, {
        isChangingOrganization: false
      })

    case SET_MAX_ACTIVE_QUESTS:
      return Object.assign({}, state, {
        maxActiveQuests: action.maxActiveQuests
      })

    default:
      return state
  }
}
